import { render, staticRenderFns } from "./TutorSummaryWrapper.vue?vue&type=template&id=48b96432&scoped=true&"
import script from "./TutorSummaryWrapper.vue?vue&type=script&lang=js&"
export * from "./TutorSummaryWrapper.vue?vue&type=script&lang=js&"
import style0 from "./TutorSummaryWrapper.vue?vue&type=style&index=0&id=48b96432&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b96432",
  null
  
)

export default component.exports